export const MIN_KEYWORD_LENGTH = 2;
export const MAX_SEARCH_PHRASE_LENGTH = 255;
/** Mirrors BulkRefreshLandscapesRequest::MAX_LANDSCAPES on the backend. */
export const MAX_LANDSCAPES_PER_REQUEST = 50;

export function isValidKeywordLength(keyword: string): boolean {
  return keyword.trim().length >= MIN_KEYWORD_LENGTH;
}

export function filterValidKeywords(keywords: string[]): { valid: string[]; tooShort: string[] } {
  const valid: string[] = [];
  const tooShort: string[] = [];
  for (const kw of keywords) {
    if (isValidKeywordLength(kw)) valid.push(kw);
    else if (kw.trim().length > 0) tooShort.push(kw);
  }
  return { valid, tooShort };
}
